import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Divider, Button, Spin } from 'antd';
import constants from '../../../constants/constants';
import { getColorClass } from '../../../functions/functions';
import { DownloadOutlined } from '@ant-design/icons';
import { fetchApi } from '../../../services/api';
import { COOKIE, getCookie } from '../../../services/cookie';

const StudyGuideResources = () => {
	const navigate = useNavigate();
	const colorCode = ['#7F1D1D', '#155E75', '#6B21A8', '#15803D'];
	const [loader, setLoader] = useState(false);
	const [studyGuideList, setStudyGuideList] = useState([]);
	const userId = getCookie(COOKIE.UserId);
	
	const routeToChapter = (chapter_id) => {
		const state = {
			chapter_id: chapter_id
		};
		navigate('/chapter-resources', { state });
	};

	const getStudyGuideList = () => {
		setLoader(true);
		fetchApi(`/study-guide-list-user`, 'post',{ stud_id: userId }).then((res) => {
			if (res?.code === 200) {
				setStudyGuideList(res?.data)
				setLoader(false);
			} else {
				setStudyGuideList([]);
				setLoader(false);
			}
		})
	};
	useEffect(() => {
		getStudyGuideList();
	}, []);

	const downloadStudyGuide = async (chapter_id, title) => {
		const response = await fetch(`${constants.ApiUrl}/download-pdf/?chapter_id=${chapter_id}&resource_type=0&stud_id=${userId}`);
		if (!response.ok) {
			console.error("Download failed");
			return;
		}
		const blob = await response.blob();
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = title;
		document.body.appendChild(a);
		a.click();
		a.remove();
		window.URL.revokeObjectURL(url);
		getStudyGuideList();
	};
	return (
		<div>
			<div className='container mx-auto pb-20'>
				<div className='flex justify-between items-center'>
					<div style={{ color: getColorClass("1", "colorcode") }} className='text-2xl underline underline-offset-4 font-extrabold uppercase'>{constants.studyGuide + "s"}</div>
				</div>
				<Divider className='my-2' />
				<Spin spinning={loader} size="large" className='z-30'>
					{studyGuideList.length > 0 ? (
						<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
							{studyGuideList.map((val, index) => (
								<div
									key={val?.chapter_id}
									id={`podcast-${val.chapter_id}`}
									className="border flex gap-4 p-4 rounded-md"
									style={{ borderColor: colorCode[index % colorCode.length] }}
								>
									{/* Chapter ID Block */}
									<div
										style={{ backgroundColor: colorCode[index % colorCode.length] }}
										className="text-white text-2xl font-bold w-20 h-18 flex items-center justify-center rounded shrink-0 cursor-pointer"
										onClick={() => routeToChapter(val?.chapter_id)}
									>
										{val?.chapter_id}
									</div>

									{/* Content */}
									<div className="flex flex-col justify-center w-full">
										{/* Title */}
										<div onClick={() => routeToChapter(val?.chapter_id)} className="font-semibold text-base sm:text-lg text-gray-800 leading-tight cursor-pointer">
											{val?.chapter_name}
										</div>

										{/* Button + Played On */}
										<div className="flex flex-col sm:flex-row sm:items-center gap-2 flex-wrap mt-2">
											<Button
												type="primary"
												className="text-white text-sm font-medium"
												style={{ backgroundColor: colorCode[index % colorCode.length] }}
												icon={<DownloadOutlined />}
												onClick={()=>downloadStudyGuide(val?.chapter_id,val?.title)}
											>
												Download
												{val.file_size && <> • &nbsp;{val.file_size}</>}
											</Button>

											{val?.date_downloaded && (
												<span className="text-sm italic text-gray-500">
													downloaded on {val?.date_downloaded}
												</span>
											)}
										</div>
									</div>
								</div>
							))}
						</div>
					) : (
						<div className="text-gray-500">No study guide found.</div>
					)}
				</Spin>
			</div>
		</div>
	)
}

export default StudyGuideResources